module.exports = __webpack_public_path__ + "media/images/salespartner/bg-mv-right-b6659f038bd6aa18be9831b5ab7e22b4.svg";